import { graphqlFetch } from '@pylot-data/graphqlFetch'
import type { CustomerInput, CustomerOutput } from '@pylot-data/fwrdschema'
import { CREATE_CUSTOMER } from './graphql/createCustomer'
import { useLogin } from './use-login'
import { useCart, mergeCarts, refreshCart } from '@corratech/pylot-cart-manager'
import { useRouter } from 'next/router'
import { useAuthUI } from './AuthContext'
import { ToastType, useUI } from '@corratech/pylot-ui/context'

export type CreateCustomerResponse = {
    data: { createCustomer: CustomerOutput }
}

export const useCreateAccount = () => {
    const { login } = useLogin()
    const { locale } = useRouter()
    const { openToast } = useUI()
    const { data, mutate: updateCart } = useCart()
    const { signUpCallbacks, clearAuthCallback } = useAuthUI()

    return {
        createAccount: async (params: CustomerInput) => {
            const createResult = await graphqlFetch<
                { input: CustomerInput },
                CreateCustomerResponse
            >({ query: CREATE_CUSTOMER, variables: { input: params }, locale })
            if (createResult.errors) throw createResult.errors
            // Se decide antes del login: al traer el carro del cliente, useCart
            // guarda su id en cart_id y ya no se distinguiría del de invitado.
            const hasGuestCart = !!localStorage.getItem('cart_id')
            await login({
                email: params.email!,
                password: params.password!
            })
            // Sin carro de invitado no hay nada que fusionar: se trae el del cliente.
            if (!hasGuestCart) {
                refreshCart()
            } else
                mergeCarts({
                    guestCartId: localStorage.getItem('cart_id')!,
                    locale
                }).then((res) => {
                    const { errors } = res
                    if (!errors) {
                        updateCart(res, false)
                    } else {
                        openToast(errors[0].message, ToastType.Warning)
                        updateCart(
                            {
                                ...data,
                                data: {
                                    cart: {
                                        ...data!.data.cart,
                                        items: [
                                            ...(data!.data.cart.items?.filter(
                                                (item) => !!item
                                            ) || [])
                                        ]
                                    }
                                }
                            },
                            false
                        )
                    }
                })
            if (signUpCallbacks.length) {
                signUpCallbacks.forEach((callback) => {
                    if (typeof callback === 'function') {
                        callback()
                    }
                })
                clearAuthCallback('SIGNUP_VIEW')
            } else {
                window.dispatchEvent(new CustomEvent('pylot:refresh-content'))
            }
            return { createResult }
        }
    }
}
